import {FC} from "react";
import {useTranslation} from "react-i18next";
import {Badge} from "@interstate/components/Badge";
import {BuildingOfficeIcon} from "@interstate/components/Icons";
import {BadgeBar} from "../../../../../badges";
import {SummaryCard} from "../../../create-hierarchy/steps/common";
import {
  Oem,
  OrganizationInformation
} from "@common-core/coat-operational-hierarchy-appsync-model";
import "../../../create-hierarchy/steps/common/BuilderStep.scss";
import "./CreateNewEntityReviewStep.scss";

export interface TestEntityReviewStepProps {
  transactionId: string;
  organizationInformation: OrganizationInformation;
  oems?: Oem[];
}

/**
 * CreateNewEntityReviewStep provides entity preview functionality for the test entity stepper.
 * Shows entity details using CreateDetailsColumn and includes summary card with "To Be Created" badge.
 * Follows the same styling and layout patterns as ReviewPlanStep.
 */
export const CreateNewEntityReviewStep: FC<TestEntityReviewStepProps> = ({
  transactionId,
  organizationInformation,
  oems
}) => {
  const {t} = useTranslation();

  return (
    <section
      data-testid={"test-entity-review-step"}
      className={"hierarchy-builder-step create-new-entity-review-step"}>
      {/* Summary Cards Section */}
      <section data-testid={"summary-section"} className={"summary-section"}>
        <SummaryCard
          baseKey={"create-new-entity.plan-summary.creating"}
          count={1}
        />
      </section>

      {/* Entity Details Section */}
      <section
        data-testid={"hierarchy-section"}
        className={"hierarchy-section"}>
        <div className="create-new-entity-item">
          <div className="entity-info">
            <span className="entity-name">
              {organizationInformation.dbaName}
            </span>
          </div>
          <BadgeBar>
            <Badge
              id={`create-new-entity-badge-${transactionId}`}
              data-testid={`create-new-entity-badge-${transactionId}`}
              className={"create-new-entity-badge"}
              variant={"success"}
              startIcon={<BuildingOfficeIcon />}>
              <span className={"create-new-entity-badge-label"}>
                {t("create-new-entity.entity-states.idle")}
              </span>
            </Badge>
          </BadgeBar>
        </div>
      </section>
    </section>
  );
};
